<template lang='pug'>
div(
  v-on-clickaway='onInputBlur'
  :class='[$style[`cc-select`], $style[beforeIcon ? `has-before-icon` : ``], $style[errorValue ? `has-error` : ``]]')

  span(v-show='beforeIcon' :class='$style[`cc-select-before-icon`]')
    IconUser(v-if='beforeIcon === `user`' :size='24' :color='beforeIconColor')
    IconMail(v-if='beforeIcon === `mail`' :size='24' :color='beforeIconColor')
    IconPassWord(v-if='beforeIcon === `password`' :size='24' :color='beforeIconColor')
    IconFilter(v-if='beforeIcon === `filter`' :size='24' :color='beforeIconColor')
    IconCure2(v-if='beforeIcon === `cure`' :size='22' :color='beforeIconColor')
    IconConfirm(v-if='beforeIcon === `confirm`' :size='24' :color='beforeIconColor')
    IconGender(v-if='beforeIcon === `gender`' :size='24' :color='beforeIconColor')
    IconTag(v-if='beforeIcon === `tag`' :size='24' :color='beforeIconColor')
    IconHelper(v-if='beforeIcon === `helper`' :size='24' :color='beforeIconColor')
    IconConfirm(v-if='beforeIcon === `confirm`' :size='24' :color='beforeIconColor')
    IconLocation(v-if='beforeIcon === `location`' :size='24' :color='beforeIconColor')
    IconMoney(v-if='beforeIcon === `money`' :size='24' :color='beforeIconColor')

  //- Select Main
  input(
    ref='selector'
    readonly
    :placeholder='!plhShow ? `` : plh'
    :class='[$style[`cc-select-area`], $style[isDisabled ? `cc-select-disable` : ``]]'
    :value='selectValue'
    @focus='onInputFocus')
    //- @blur='onInputBlur'

  //- Select Submenu
  //- transition(name='ani-slide-up-fade')
  div.select-option(v-if='subMenuShow' :class='$style[`cc-select-option`]')
    ul(:class='$style[`cc-select-option-list`]')
      li(
        v-for='(items, index) in optionList'
        :key='index'
        @click='setSelectValue(items)') {{ items }}

</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

import IconClose from '../../icon/Close';
import IconUser from '../../icon/User';
import IconMail from '../../icon/Mail';
import IconPassWord from '../../icon/Password';
import IconFilter from '../../icon/Filter';
import IconConfirm from '../../icon/Confirm';
import IconGender from '../../icon/Gender';
import IconTag from '../../icon/Tag';
import IconCure2 from '../../icon/Cure2';
import IconHelper from '../../icon/Helper';
import IconLocation from '../../icon/Location';
import IconMoney from '../../icon/Money';

export default {
  components: {
    IconClose,
    IconUser,
    IconMail,
    IconPassWord,
    IconConfirm,
    IconFilter,
    IconGender,
    IconTag,
    IconCure2,
    IconHelper,
    IconLocation,
    IconMoney,
  },

  mixins: [clickaway],

  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: String,
      default: '',
    },
    beforeIcon: {
      type: String,
      default: '',
    },
    beforeIconSize: {
      type: Number,
      default: 20,
    },
    beforeIconColor: {
      type: String,
      default: '#000',
    },
    placeholder: {
      type: String,
      default: '',
    },
    errorValue: {
      type: Boolean,
      default: false,
    },
    optionList: Array,
  },

  data() {
    return {
      plh: this.placeholder,
      plhShow: true,
      subMenuShow: false,
      selectValue: this.defaultValue,
    };
  },

  mounted() {
    // this.$nextTick(() => {
    //   this.$refs.selector.value = this.defaultValue;
    // })
    this.$refs.selector.value = this.defaultValue;
  },

  methods: {
    setSelectValue(newValue) {
      this.plhShow = false;
      this.selectValue = newValue;
      this.$emit('sendSelectValue', this.selectValue);
      this.$emit('clearErrorMsg', false);
      this.subMenuShow = false;
    },

    onInputFocus() {
      if (this.isDisabled) { return; }
      this.plhShow = false;
      this.subMenuShow = true;
    },

    onInputBlur() {
      if (this.isDisabled) { return; }
      this.plhShow = true;
      this.subMenuShow = false;
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/common/select.scss';
</style>
